import React from "react";
import ReactDOM from "react-dom";
import DeleteCommonModal from "../../../components/deleteCommonModal.component";
import EditMetric from "../../../components/okr/wizard/editMetric.component";
import InlineKrEditComp from "../../../components/okr/wizard/krInlineEdit.component";
import BasicKrComp from "./basicKrComponent";
import {
  reactLoader,
  removeReactLoader,
  autoResizeTextArea,
  WbEventHandlerMixins,
  getKrWeightModalZIndex,
} from "../../../utils/common.js";
import GoalServices from "./../../../services/goal.services";
import KrWeighting from "../../../components/okr/wizard/krWeight.component";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import KrCluster from '../kr-cluster/kr-cluster.component';
import { ThemeProvider, Modal, ModalWrapper, ModalHeader, ModalContent, ModalBackdrop, Button } from '@workboard/wobo-ui';
import { KeyDownEvent } from '../../../utils/eventKey';
import styled from "styled-components";
import { krdetailConstants as Constants } from '../../../constants/krdetails.constants';
import { getExternalAppIconClass, getExternalAppIconDataUri, getKpiExternalAppDisplayNameById } from "../../../utils/kpi-market-place-util";
import { CoauthorButtonGroup, CoauthorButtonWithPortal, getCoauthorConfig } from "./coauthor";
import he from 'he';
import { formatNumber } from "../../../utils/numberFormat";
import { sumIncludedMetricsWeightage, krSharePercentFromStoredWeightage, KR_WEIGHT_MULTIPLIER_INPUT_DECIMAL_PLACES, formatKrSharePercentDisplay, isMetricCountedForKrWeighting, quantizeKrWeightMultipliersWithRemainderApportion } from "../../../utils/krWeightageScale";

function isKrWeightEditorVisible(goalDetails) {
  return Boolean(
    goalDetails?.isKrWeightingEnabled
    && goalDetails?.metrics
    && goalDetails.metrics.length > 0
  );
}

function isKrWeightResetToDefaultsVisible(goalDetails) {
  return isKrWeightEditorVisible(goalDetails);
}

const StyledModal = styled(Modal)`
  .MuiModal-root {
    z-index: ${(p) => p.$weightModalZIndex} !important;
  }
  ${ModalBackdrop} {
    z-index: ${(p) => p.$weightModalZIndex} !important;
  }
  ${ModalWrapper} {
    width: 900px;
    z-index: ${(p) => p.$weightModalZIndex} !important;
  }
  ${ModalHeader} {
    padding: 10px 20px !important;
    h1 {
      font-size: 16px !important;
    }
  }
  ${ModalContent} {
    padding: 0px !important;
  }
  & .kr-weight-modal-footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    gap: 12px;
    box-sizing: border-box;
    border-top: 1px solid #dfe1e6;
    padding: 12px 16px;
  }
  & .kr-weight-modal-footer__right {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
  }
  & .kr-weight-modal-footer__reset {
    color: #bf2600;
    font-weight: 700;
  }
  & .kr-weight-modal-footer__reset:hover {
    color: #ae2a19;
  }
`;

const TEXTAREA_IDS = {
  newKR: 'krTextarea',
  inlineEdit: 'editGoalNameclassId',
}

class AddKrSection extends React.Component {
  constructor(props) {
    super(props);
    const { t } = this.props;
    let isMetricsList =
      this.props.goalDetails &&
      this.props.goalDetails.metrics !== undefined &&
      Object.keys(this.props.goalDetails.metrics).length > 0
        ? true
        : false;
    this.state = {
      predicted: 'no',
      setKr: true,
      addKrValue: "",
      addKrFinished: false,
      MeasureEn: false,
      intervalEn: false,
      ErrorDis: false,
      isWeightOpen: false,

      krTextField:
        this.props.goalDetails &&
        this.props.goalDetails.metrics !== undefined &&
        Object.keys(this.props.goalDetails.metrics).length > 0
          ? false
          : true,
      krListEn:
        this.props.goalDetails && this.props.goalDetails.metrics !== undefined
          ? true
          : false,
      addNotherKr:
        this.props.goalDetails &&
        this.props.goalDetails.metrics !== undefined &&
        Object.keys(this.props.goalDetails.metrics).length > 0
          ? true
          : false,
      rightKrpane: false,
      deleteKr: false,
      deleteKrList: false,
      advancedOptionEn: false,
      deleteTitle: t("Exit without saving"),
      deleteContentOne: t("Are you sure you want to"),
      buttonText: t("Exit"),
      countBasicKr: 0,
      inlineEditKr: false,
      editMetricCompEn: false,
      editKrValue: "",
      deleteKrId: "",
      krEditId: false,
      btnState: false,
      advanceOptionEn: true,
      krType: "person",
      krItem: [],
      krRightPaneDelete: false,
      krEditItem: [],
      showDragIcon: false,
      krWeightage: {},
      krWeightSaveAttempted: false,
      krWeightValidationErrors: [],
      resetDefaultWeightsOpen: false,
      items:
        this.props.goalDetails &&
        this.props.goalDetails.metrics &&
        this.props.goalDetails.metrics.length > 0
          ? this.props.goalDetails.metrics
          : [],
      clusterItem: this.props.clusterItem || [],
      nlpTags: [],
      reqFieldError: false,
      isStretchEnabled: this.props.addOkrData.isStretchEnabled ??  this.props.goalDetails.isStretchEnabled ?? false,
      ...(this.props.addOkrData.openWithAddNewKr ? {
        setKr: true,
        krTextField: true,
        addNotherKr: false,
        advancedOptionEn: true,
        advanceOptionEn: true,
        addKrFinished: false
      } : {})
    };
    this.handleKrChange = this.handleKrChange.bind(this);
    this.saveKrs = this.saveKrs.bind(this);
    this.cancelKr = this.cancelKr.bind(this);
    this.exitDeleteModal = this.exitDeleteModal.bind(this);
    this.deleteItems = this.deleteItems.bind(this);
    this.onEnterPress = this.onEnterPress.bind(this);
    this.handleSaveKrChange = this.handleSaveKrChange.bind(this);
    this.UpdateKrName = this.UpdateKrName.bind(this);
    this.handleDoubleClickItem = this.handleDoubleClickItem.bind(this);
    this.GoalServices = new GoalServices();
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.resetKr = this.resetKr.bind(this);
    this.editMetricCompFun = this.editMetricCompFun.bind(this);
    this.closeKrRightPane = this.closeKrRightPane.bind(this);
    this.editKrItem = this.editKrItem.bind(this);
    this.advancedFunc = this.advancedFunc.bind(this);
    this.krDelete = this.krDelete.bind(this);
    this.weightKr = this.weightKr.bind(this);
    this.onDragEnd = this.onDragEnd.bind(this);
    this.metadataText = this.metadataText.bind(this);
    this.inlineKrUpdate = this.inlineKrUpdate.bind(this);
    this.getSymbol = this.getSymbol.bind(this);
    this.addAnotherkr = this.addAnotherkr.bind(this);
    this.returnNumberSuffix = this.returnNumberSuffix.bind(this);
    this.getKey = this.getKey.bind(this);
    this.metadataForLinkText = this.metadataForLinkText.bind(this);
    this.MetricChangeWeight = this.MetricChangeWeight.bind(this);
    this.updateClusterData = this.updateClusterData.bind(this);
    this.saveWeightKr = this.saveWeightKr.bind(this);
    this.cancelWeightKr = this.cancelWeightKr.bind(this);
    this.krWeightPercentChange = this.krWeightPercentChange.bind(this);
    this.updateKRDataObject = this.updateKRDataObject.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.openResetDefaultWeightsConfirm = this.openResetDefaultWeightsConfirm.bind(this);
    this.exitResetDefaultWeightsModal = this.exitResetDefaultWeightsModal.bind(this);
    this.confirmResetDefaultWeights = this.confirmResetDefaultWeights.bind(this);
  }



  getKey() {
    return this.keyCount++;
  }

  MetricChangeWeight(paramKr) {
    let { actions } = this.props;
    if (!paramKr) {
      return;
    }
    const items = Array.isArray(paramKr)
      ? Object.fromEntries(
          paramKr.map((row, index) => [String(row.id != null ? row.id : index), row]),
        )
      : paramKr;
    actions.updateKrWeight(items);
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
    // IE Placeholder
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
      $(".basicTextplace").placeHolder();
    }
    window.addEventListener('coauthorSaveKeyResult', this.handleCoauthorSaveKeyResult);
    this.getTeamOptions();
    this.getTimePeriodOptions();
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
    window.removeEventListener('coauthorSaveKeyResult', this.handleCoauthorSaveKeyResult);
  }

  handleCoauthorSaveKeyResult = (e) => {
    const { value, originatorId, krSlotIndex } = e.detail;
    switch(originatorId) {
      case TEXTAREA_IDS.newKR:
        this.getTextFocus.value = value;
        this.handleKrChange({ target: { value }});
        this.onEnterPress();
        break;
      case TEXTAREA_IDS.inlineEdit:
        this.setState({ editKrValue: value });
        const metric = this.props.goalDetails.metrics[krSlotIndex];
        this.UpdateKrName(metric.id, metric, krSlotIndex);
        break;
      default:
        // No action needed
        break;
    }
  }


  updateClusterData(resp) {
		this.setState({
			clusterItem: resp
		})
	}

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutside(event) {
    let that = this;
    let keyId = that.state.krEditId;
    let keyItem = that.state.krEditItem;
    const coauthorDialogSelector = '[role="dialog"][aria-label="Co-Author"]';
    if (
      !$(".inlineMetricEdit").is(event.target) &&
      $(".inlineMetricEdit").has(event.target).length === 0 &&
      (!$(".krNamesList").is(event.target) &&
        $(".krNamesList").has(event.target).length === 0) &&
      (!$(".krInlineSave").is(event.target) &&
        $(".krInlineSave").has(event.target).length === 0) &&
      (!$(".krInlineCancel").is(event.target) &&
        $(".krInlineCancel").has(event.target).length === 0) &&
      (!$(coauthorDialogSelector).is(event.target) &&
        $(coauthorDialogSelector).has(event.target).length === 0)
    ) {
      setTimeout(function() {
        that.UpdateKrName(keyId, keyItem);
      }, 10);
    }
  }

  handleKrChange(event) {
    autoResizeTextArea(event.target);
    let krNameText = event.target.value != "" ? event.target.value : "";
    this.setState({
      addKrValue: event.target.value,
      addKrFinished: event.target.value != "" ? true : false,

      // advanceOptionEn: event.target.value != "" ? true : false
    });
    this.props.krTextWithOutsave(krNameText);
  }
  inlineKrUpdate(newName) {
    this.setState({
      addKrValue: newName
    });
  }
  handleSaveKrChange(val) {
    this.setState({
      editKrValue: val
    });
  }

  saveKrs(formData, triggerGoalCluster) {
    const { owner_id, team_id } = this.props.goalDetails;

    this.setState({ btnState: true });
    reactLoader(true);
    if (formData) {
      let { actions } = this.props;
      let goalId = this.props.goalDetails.id;
      if(this.props.goalDetails.all_metrics == 0 && this.props.goalDetails.type == 1) {
        if(this.props.goalDetails.default_permission && Object.keys(this.props.goalDetails.default_permission).length > 0) {
          formData['permission'] = this.props.goalDetails.default_permission;
        }
        if(this.props.goalDetails.default_permission_teams &&	Object.keys(this.props.goalDetails.default_permission_teams).length > 0) {
          formData['permission_teams'] = this.props.goalDetails.default_permission_teams.map(function(m) { return m.id });
        }
      }
      formData['predicted_initial_data'] = this.state.krExtractInitialValue;
      formData['predicted_target'] = this.state.krExtractTargetValue;
      formData['predicted_metric'] = this.state.krExtractValueType;
      formData['predicted_direction'] = this.state.krExtractDirectionValue;
      formData['predicted_name'] = this.state.krExtractName;
      formData['predicted'] = this.state.predicted;
      formData['inline'] = !this.state.inlineEditKr;
      formData['name'] = he.encode(this.state.addKrValue);
      if(this.props.addOkrData.groupKRCustomFields){
        let customCategorys = Object.values(this.props.addOkrData.groupKRCustomFields)
        let tempField = customCategorys.map(i => Object.values(i.customFields))
        let reqField = [];
        tempField.forEach(i=>{
          i.forEach(j=>{
            reqField.push(j.is_required)
          })
        })
        if(reqField.includes('1')){
          removeReactLoader();
          this.setState({ reqFieldError: true});
        }
        else{
          this.GoalServices.addEditKr({ goalId: goalId, metric: formData }).then(
            response => {
              removeReactLoader();
              document.getElementById("krHeadTextId").focus();
              if (response.data) {
                let result = response.data.data;
                let krWeightage = result.krWeightage;
                delete result["krWeightage"];
                result.name = he.decode(this.state.addKrValue);
                actions.addNewKr(result);
                this.props.saveKrArr();
                this.MetricChangeWeight(krWeightage);
                this.setState({
                  krListEn: true,
                  addNotherKr: true,
                  krTextField: false,
                  ErrorDis: false,
                  btnState: false,
                  setKr: true,
                  advanceOptionEn: true,
                  addKrValue: "",
                  krNameText: ""
                });
                // this.GoalServices.triggerGoalMetricDetails({ goalId });
                if(triggerGoalCluster && (this.props.addOkrData && this.props.addOkrData.display_kr_clustering)){
                  // callback(response.data.data.id)
                  this.GoalServices.getClusterData({ goalId: this.props.goalDetails.id}).then(response => {
                        if (response.status === 200) {
                            this.props.actions.updateClusterData(response.data.data);
                        }
                    })
                }

                window.wb_track('KR_CREATE', {
                  UserId: window.uData.user_id,
                  OrgId: window.uData.org_id,
                  Timestamp: Date.now(),
                  TeamId: team_id,
                  OwnerId: owner_id,
                  KrId: result.id,
                  UpdateFrequency: formData.intervalText,
                });
              }
            }
          );
        }
      }
      else{
        this.GoalServices.addEditKr({ goalId: goalId, metric: formData }).then(
          response => {
            removeReactLoader();
            document.getElementById("krHeadTextId").focus();
            if (response.data) {
              let result = response.data.data;
              let krWeightage = result.krWeightage;
              delete result["krWeightage"];
              result.name = he.decode(this.state.addKrValue);
              actions.addNewKr(result);
              this.props.saveKrArr();
              this.MetricChangeWeight(krWeightage);
              this.setState({
                krListEn: true,
                addNotherKr: true,
                krTextField: false,
                ErrorDis: false,
                btnState: false,
                setKr: true,
                advanceOptionEn: true,
                addKrValue: "",
                krNameText: ""
              });
              if(triggerGoalCluster && (this.props.addOkrData && this.props.addOkrData.display_kr_clustering)){
                this.GoalServices.getClusterData({ goalId: this.props.goalDetails.id}).then(response => {
                      if (response.status === 200) {
                          this.props.actions.updateClusterData(response.data.data);
                      }
                  })
              }

              window.wb_track('KR_CREATE', {
                UserId: window.uData.user_id,
                OrgId: window.uData.org_id,
                Timestamp: Date.now(),
                TeamId: team_id,
                OwnerId: owner_id,
                KrId: result.id,
                UpdateFrequency: formData.intervalText,
              });
            }
          }
        );
      }

    }
  }

  cancelKr() {
    this.props.cancelKrInfo();
  }

  exitDeleteModal() {
    this.setState({ deleteKrList: false });
  }

  krDelete(id) {
    this.setState({
      deleteKrList: true,
      deleteKrId: id,
      krRightPaneDelete: true,
      addKrFinished: false
    });
    return overflowHiddenFunction(false);
  }

  deleteItems(id) {
    let _that = this;
    let { actions } = _that.props;
    if (id != "" && id != undefined) {
      // delete goal and update JSON
      this.GoalServices.deleteMetric({ metricId: id }).then(response => {
        if (response.data) {
          actions.deleteNewKr(id);
          if(this.props.addOkrData && this.props.addOkrData.display_kr_clustering) {
            this.GoalServices.getClusterData({ goalId: this.props.goalDetails.id}).then(res => {
              if (res.status === 200) {
                this.props.actions.updateClusterData(res.data.data);
                this.setState({
                  clusterItem: res.data.data.metrics
                });
              }
            })
          }
          this.setState({
            deleteKrList: false,
            deleteKrId: "",
            krTextField:
              this.props.goalDetails &&
              this.props.goalDetails.metrics !== undefined &&
              this.props.goalDetails.metrics.length > 0
                ? false
                : true,
            addNotherKr:
              this.props.goalDetails &&
              this.props.goalDetails.metrics !== undefined &&
              this.props.goalDetails.metrics.length > 0
                ? true
                : false
          });
          if (this.state.krRightPaneDelete) {
            ReactDOM.unmountComponentAtNode(
              document.getElementById("mySidenas")
            );
          }
          this.MetricChangeWeight(response.data.data.krWeightage);
        }
      });
      this.handleFocus()
    } else {
      this.setState({
        deleteKrList: false,
        deleteKrId: "",
        krTextField:
          this.props.goalDetails &&
          this.props.goalDetails.metrics !== undefined &&
          Object.keys(this.props.goalDetails.metrics).length > 0
            ? false
            : true,
        setKr: true,
        advanceOptionEn: true,
        addKrValue: "",
        addKrFinished: false,
        addNotherKr:
          this.props.goalDetails &&
          this.props.goalDetails.metrics !== undefined &&
          Object.keys(this.props.goalDetails.metrics).length > 0
            ? true
            : false
      });
      $(".basicTextplace").val("");
      let krtext = "";
      this.props.krTextWithOutsave(krtext);
      if (this.state.krRightPaneDelete) {
        ReactDOM.unmountComponentAtNode(document.getElementById("mySidenas"));
      } else {
        //this.props.unmountGoalComp();
      }

      this.handleFocus()
    }
  }

  handleFocus() {
    const btnToFocus = document.querySelector('.woboGoalDoneBtn')
    if (btnToFocus){
      setTimeout(() => {
        btnToFocus.focus()
      }, 500)
    }
  }

  deleteMetric(id) {
    this.setState({ deleteKrList: true, deleteKrId: id });
  }

  onEnterPress(e) {
    if (!e || e.keyCode === 13) {
      e?.preventDefault();
      if (
        this.state.addKrValue != "" &&
        this.state.addKrValue !== "" &&
        this.state.addKrValue != undefined
      ) {
        this.setState({
          setKr: false,
          addKrFinished: false,
          advanceOptionEn: false
        });
        if (this.state.addKrValue) {
          this.GoalServices.getKRExtract({krName: this.state.addKrValue}).then(response => {
            if (response.status === 200 && (response.data?.data?.InitialValue || response.data?.data?.TargetValue)) {
              this.setState({
                krExtractInitialValue: response.data?.data?.InitialValue,
                krExtractTargetValue: response.data?.data?.TargetValue,
                krExtractValueType: response.data?.data?.ValueType,
                krExtractDirectionValue: response.data?.data?.DirectionValue,
                krExtractName: this.state.addKrValue,
                predicted: response.data?.data? 'yes' : 'no'
              })
            } else if (response.data.status !== 'fatal_error') {
              // If there is no prediction then we wanted to auto fill with 0, 100, %, increase
              // at the same time if for some reason we don't have API response we are not defaulting these
              this.setState({
                krExtractInitialValue: 0,
                krExtractTargetValue: 100,
                krExtractValueType: 3,
                krExtractDirectionValue: 1,
                predicted: 'no'
              });
            }
          })
        }
        if(this.props.addOkrData && this.props.addOkrData.display_kr_clustering) {
          this.GoalServices.getClusterData({ goalId: this.props.addOkrData.goalDetails.id, metricId: 0, text: this.state.addKrValue}).then(response => {
            if (response.status === 200) {
              this.setState({
                clusterItem: response.data.data.metrics
              })
              // actions.updateClusterDataForIndividualItem({resp:response.data.data, item: item});
            }
          })
        }
      }
    }
    //this.setState({ addKrFinished: false });
  }

  handleDoubleClickItem(id, krInline) {
    if(krInline.source !=11) {
      this.setState({
        inlineEditKr: !this.state.inlineEditKr,
        krEditId: id,
        krEditItem: krInline,
        editKrValue:""
      });
    }
  }

  sendFocusToKrresult = (index) =>{
    setTimeout(() => {
      const e = document.getElementById("krEditSaveid_"+index);
      if (e) {
        e.focus();
      }
    });
  }

  UpdateKrName(krId, item, index) {
    const e = document.getElementById("krNameEmpty_"+index);
    if (e) {
      e.focus();
    }
    if (
      krId != "" &&
      krId != null &&
      krId != undefined &&
      this.state.editKrValue != "" &&
      this.state.editKrValue != undefined
    ) {
      if (this.state.editKrValue != "") {
        item.name = this.state.editKrValue;
      }
      if (item) {
        let { actions } = this.props;
        const krName = he.encode(this.state.editKrValue);
        this.GoalServices.updateMetricName({
          goal_id: item.goal_id,
          metric_id: krId,
          metric_name: krName
        }).then(response => {
          if (response.data) {
            const decodedKrName = he.decode(this.state.editKrValue);
            actions.updateKrName(krId, decodedKrName);
            this.setState({
              inlineEditKr: false,
              krEditId: "",
              krEditItem: []
            });
            this.sendFocusToKrresult(index);
            if(this.props.addOkrData && this.props.addOkrData.display_kr_clustering) {
              this.GoalServices.getClusterData({ goalId: this.props.goalDetails.id}).then(res => {
                if (res.status === 200) {
                  this.props.actions.updateClusterData(res.data.data);
                  this.setState({
                    clusterItem: res.data.data.metrics
                  });
                  if($('.kritems[data-rbd-draggable-id='+krId+']').find('.krCluster')) {
                    $('.kritems[data-rbd-draggable-id='+krId+']').find('.krCluster').addClass('ovalClicked');
                    let clusterTimer = setInterval(() => {
                      if($('.kritems[data-rbd-draggable-id='+krId+']').find('.krCluster').hasClass('ovalClicked'))
                      $('.kritems[data-rbd-draggable-id='+krId+']').find('.krCluster').removeClass('ovalClicked');
                      else
                      $('.kritems[data-rbd-draggable-id='+krId+']').find('.krCluster').addClass('ovalClicked');
                    }, 300);
                    setTimeout(() => {
                      clearInterval(clusterTimer);
                      if($('.kritems[data-rbd-draggable-id='+krId+']').find('.krCluster').hasClass('ovalClicked'))
                      $('.kritems[data-rbd-draggable-id='+krId+']').find('.krCluster').removeClass('ovalClicked');
                    },3000);
                  }
                }
              })
            }
          }
        });
        this.GoalServices.getClusterFireEvent({type: 'KR_CLUSTER_KR_NAME_CHANGED', source: 'KR_EDIT'})
      } else {
        this.setState({
          inlineEditKr: false,
          krEditId: "",
          krEditItem: []
        });
        this.sendFocusToKrresult(index);
      }
    } else {
      this.setState({
        inlineEditKr: false,
        krEditId: "",
        krEditItem: []
      });
      this.sendFocusToKrresult(index);
    }
  }

  resetKr() {
    this.setState({ deleteKrList: true });
  }
  editMetricCompFun(inlineData, krItem, krtype = "person",selectednlplTags=[],nplTags=[],selectednlplTagsName=[],tagsList=[]) {
    let item = {
      clusterItems: krItem,
      clusterCount: krItem.length
    }
    this.advancedFunc(krtype, item, inlineData,selectednlplTags,nplTags,selectednlplTagsName,tagsList);
  }
  metricText(metric) {
    const { t } = this.props
    let textMetric = "";
    if (metric == 1) {
      textMetric = t("number");
    } else if (metric == 2) {
      textMetric = t("currency");
    } else if (metric == 3) {
      textMetric = t("percentage");
    }
    return textMetric;
  }

  dayFunction(weekly_update_day) {
    const { t } = this.props;
    let whichDay = "";
    if (weekly_update_day == 1) {
      whichDay = t("every Monday");
    } else if (weekly_update_day == 2) {
      whichDay = t("every Tuesday");
    } else if (weekly_update_day == 3) {
      whichDay = t("every Wednesday");
    } else if (weekly_update_day == 4) {
      whichDay = t("every Thursday");
    } else if (weekly_update_day == 5) {
      whichDay = t("every Friday");
    } else if (weekly_update_day == 6) {
      whichDay = t("every Saturday");
    } else if (weekly_update_day == 7) {
      whichDay = t("every Sunday");
    }
    return whichDay;
  }

  intervalText(interval, weekly_update_day) {
    const { t } = this.props;
    let intervalMetric = "";
    if (interval == 1) {
      intervalMetric = t("daily");
    } else if (interval == 2) {
      intervalMetric = this.dayFunction(weekly_update_day);
    } else if (interval == 3) {
      intervalMetric = t("monthly");
    } else if (interval == 4) {
      intervalMetric = t("quarterly");
    } else if (interval == 5) {
      intervalMetric = t("once");
    }
    return intervalMetric;
  }

  closeKrRightPane(check, krId) {
    if (check) {
      this.setState({
        editMetricCompEn: !this.state.editMetricCompEn,
        krListEn: true,
        setKr: true,
        addKrValue: "",
        krNameText: "",
        addKrFinished: false,
        advanceOptionEn: true,
        addNotherKr:
          this.props.goalDetails &&
          this.props.goalDetails.metrics !== undefined &&
          Object.keys(this.props.goalDetails.metrics).length > 0
            ? true
            : false,
        krTextField:
          this.props.goalDetails &&
          this.props.goalDetails.metrics !== undefined &&
          Object.keys(this.props.goalDetails.metrics).length > 0
            ? false
            : true
      });
      if (this.state.krTextField) {
        $(".basicTextplace").val("");
      }
      this.props.emprtyKrName();
    }
    if(this.props.addOkrData && this.props.addOkrData.display_kr_clustering) {
      this.GoalServices.getClusterData({ goalId: this.props.goalDetails.id}).then(res => {
        if (res.status === 200) {
          this.props.actions.updateClusterData(res.data.data);
          this.setState({
            clusterItem: res.data.data.metrics
          });
          if(krId && $('.kritems[data-rbd-draggable-id='+krId+']').find('.krCluster')) {
            $('.kritems[data-rbd-draggable-id='+krId+']').find('.krCluster').addClass('ovalClicked');
            let clusterTimer = setInterval(() => {
              if($('.kritems[data-rbd-draggable-id='+krId+']').find('.krCluster').hasClass('ovalClicked'))
              $('.kritems[data-rbd-draggable-id='+krId+']').find('.krCluster').removeClass('ovalClicked');
              else
              $('.kritems[data-rbd-draggable-id='+krId+']').find('.krCluster').addClass('ovalClicked');
            }, 300);
            setTimeout(() => {
              clearInterval(clusterTimer);
              if($('.kritems[data-rbd-draggable-id='+krId+']').find('.krCluster').hasClass('ovalClicked'))
              $('.kritems[data-rbd-draggable-id='+krId+']').find('.krCluster').removeClass('ovalClicked');
            },3000);
          }
        }
      })
    }

    if (document.getElementById("mySidenas")) {
      ReactDOM.unmountComponentAtNode(document.getElementById("mySidenas"));
    }
    $(".goalPopupNew").css("overflow", "initial");
    return overflowHiddenFunction(false);
  }

  editKrItem(e, item) {
    let krType = WbEventHandlerMixins.getKrType(item.source, item.type, item.ext_app_id);
    this.advancedFunc(krType, item);
  }

  updateKRDataObject(val, item)
  {
    let krType = WbEventHandlerMixins.getKrType(item.source, item.type, item.ext_app_id);
    this.advancedFunc(krType, {...item, name: val});
  }

  advancedFunc(krTypes, krItem, inlineData,selectednlplTags=[],nplTags=[],selectednlplTagsName=[],tagsList=[]) {
    let basicInlineData = [];
    if (typeof inlineData != "undefined") {
      basicInlineData = inlineData;
    }
    ReactDOM.render(
      <EditMetric
        {...this.props}
        krType={krTypes}
        closeKrRightPane={this.closeKrRightPane}
        item={krItem}
        krDelete={this.krDelete}
        addKrValue={this.state.addKrValue}
        basicInlineData={basicInlineData}
        MetricChangeWeight={this.MetricChangeWeight}
        updateKRStates={this.updateAllStates}
        integrations={this.props.addOkrData.integrations}
        updateSingleItem={(metric) => this.editKrItem(null, metric) }
        updateKRDataObject={this.updateKRDataObject}
        selectednlplTags={selectednlplTags}
        selectednlplTagsName={selectednlplTagsName}
        nplTags={nplTags}
        tagsList={tagsList}
      />,
      document.getElementById("mySidenas")
    );

    const { owner_id, team_id } = this.props.goalDetails;
    window.wb_track('KR_ADVANCED', {
      UserId: window.uData.user_id,
      OrgId: window.uData.org_id,
      Timestamp: Date.now(),
      TeamId: team_id,
      OwnerId: owner_id,
      KrId: krItem.id,
    });
  }

  weightKr() {
    const item = this.props.goalDetails
    if (!isKrWeightEditorVisible(item)) {
      return
    }
    if (item.metrics && item.metrics.length && item.isKrWeightageSuppressed) {
      const krWeightage = {}
      item.metrics.forEach((m) => {
        krWeightage[m.id] =
          isMetricCountedForKrWeighting(m) ? { percent: '' } : { percent: '0' }
      })
      this.setState({
        krWeightage,
        isWeightOpen: true,
        krWeightSaveAttempted: false,
        krWeightValidationErrors: [],
      })
      return
    }
    const krMetricWeiDataLength = item.metrics.length
    const isKrMultiperAlter = item.isKrMultiperAlter

    if (krMetricWeiDataLength) {
      const krWeightage = {}
      const metrics = item.metrics
      const included = metrics.filter((m) => isMetricCountedForKrWeighting(m))
      const anyMultiplier = included.some(
        (m) => parseFloat(m.multiplier) > 0
      )
      const hasStoredWeightage = included.some(
        (m) =>
          m.weightage !== null &&
          m.weightage !== undefined &&
          m.weightage !== ''
      )
      /** Persisted system defaults include multiplier; only coerce 0→1 when the row has no stored default. */
      const useStoredWeightage = !anyMultiplier && hasStoredWeightage
      const systemQuantize = !isKrMultiperAlter

      if (useStoredWeightage) {
        const totalW = sumIncludedMetricsWeightage(metrics)
        if (systemQuantize && totalW > 0) {
          const idealById = {}
          metrics.forEach((i) => {
            if (!isMetricCountedForKrWeighting(i)) {
              return
            }
            const wt = Number(String(i.weightage).replace(/%$/, '').trim()) || 0
            idealById[i.id] = wt / totalW
          })
          const quantized = quantizeKrWeightMultipliersWithRemainderApportion(idealById)
          metrics.forEach((i) => {
            if (!isMetricCountedForKrWeighting(i)) {
              krWeightage[i.id] = { percent: '0' }
              return
            }
            krWeightage[i.id] = {
              percent: String(quantized[i.id] ?? 0),
            }
          })
        } else {
          metrics.forEach((i) => {
            if (!isMetricCountedForKrWeighting(i)) {
              krWeightage[i.id] = { percent: '0' }
              return
            }
            const wt = Number(String(i.weightage).replace(/%$/, '').trim()) || 0
            const displayPct = krSharePercentFromStoredWeightage(wt, totalW)
            krWeightage[i.id] = {
              percent: String(displayPct),
            }
          })
        }
      } else if (systemQuantize) {
        const idealById = {}
        metrics.forEach((i) => {
          if (!isMetricCountedForKrWeighting(i)) {
            return
          }
          let val = i.multiplier
          const hasRowWeightage = i.weightage != null && i.weightage !== ''
          if (val == 0 && !isKrMultiperAlter && !hasRowWeightage) {
            val = 1
          }
          const v = parseFloat(val)
          idealById[i.id] = v > 0 ? v : 0
        })
        const quantized = quantizeKrWeightMultipliersWithRemainderApportion(idealById)
        metrics.forEach((i) => {
          if (!isMetricCountedForKrWeighting(i)) {
            krWeightage[i.id] = { percent: '0' }
            return
          }
          krWeightage[i.id] = { percent: String(quantized[i.id] ?? 0) }
        })
      } else {
        metrics.forEach((i) => {
          if (!isMetricCountedForKrWeighting(i)) {
            krWeightage[i.id] = { percent: '0' }
            return
          }
          let val = i.multiplier
          const hasRowWeightage = i.weightage != null && i.weightage !== ''
          if (val == 0 && !isKrMultiperAlter && !hasRowWeightage) {
            val = 1
          }
          const v = parseFloat(val)
          krWeightage[i.id] = { percent: String(v > 0 ? v : 0) }
        })
      }
      this.setState({
        krWeightage,
        isWeightOpen: true,
        krWeightSaveAttempted: false,
        krWeightValidationErrors: [],
      });
      return;
    }
    this.setState({
      isWeightOpen: true,
      krWeightSaveAttempted: false,
      krWeightValidationErrors: [],
    });
  }

  canSaveKrWeights() {
    const metrics = this.props.goalDetails.metrics
    if (!Array.isArray(metrics)) {
      return false
    }
    const includedCount = metrics.filter((m) => isMetricCountedForKrWeighting(m)).length
    return includedCount > 0
  }

  collectKrWeightSaveValidationErrors() {
    const { t } = this.props
    const metrics = this.props.goalDetails.metrics
    const { krWeightage } = this.state
    const errors = []
    if (!Array.isArray(metrics)) {
      return errors
    }
    const included = metrics.filter((m) => isMetricCountedForKrWeighting(m))
    if (included.length === 0) {
      errors.push(
        t(
          'Add at least one key result that counts toward objective progress before setting weights.',
        ),
      )
      return errors
    }

    for (const m of included) {
      const raw = krWeightage[m.id]?.percent
      if (raw === '' || raw == null || typeof raw === 'undefined') {
        errors.push(
          t('Enter a multiplier for each key result that counts toward progress.'),
        )
        return errors
      }
    }

    for (const m of included) {
      const str = String(krWeightage[m.id].percent).trim()
      const dot = str.indexOf('.')
      if (dot !== -1 && str.slice(dot + 1).length > KR_WEIGHT_MULTIPLIER_INPUT_DECIMAL_PLACES) {
        errors.push(
          t(
            'Use at most {{n}} decimal places for each multiplier (for example, 43.456).',
            { n: KR_WEIGHT_MULTIPLIER_INPUT_DECIMAL_PLACES },
          ),
        )
        return errors
      }
      const n = parseFloat(str)
      if (!Number.isFinite(n)) {
        errors.push(t('Enter a valid number for each multiplier.'))
        return errors
      }
      if (n < 0) {
        errors.push(t('Multipliers cannot be negative.'))
        return errors
      }
    }

    return errors
  }

  krWeightPercentChange(krId, percent) {
    this.setState((prev) => {
      const krWeightage = { ...prev.krWeightage }
      if (krWeightage[krId] == null) {
        krWeightage[krId] = { percent: '' }
      }
      let nextPct
      if (percent === '' || percent === null || typeof percent === 'undefined') {
        nextPct = ''
      } else if (typeof percent === 'string') {
        nextPct = percent
      } else if (typeof percent === 'number' && Number.isFinite(percent)) {
        nextPct = String(percent)
      } else {
        return null
      }
      krWeightage[krId] = {
        ...krWeightage[krId],
        percent: nextPct,
      }
      return {
        krWeightage,
        krWeightSaveAttempted: false,
        krWeightValidationErrors: [],
      }
    })
  }

  cancelWeightKr(props, param) {
    if (param == "save") {
      let { actions } = props;
      actions.updateIsKrMultiper();
    }
    this.setState({
      isWeightOpen: false,
      krWeightSaveAttempted: false,
      krWeightValidationErrors: [],
      krWeightage: {},
    });
  }

  openResetDefaultWeightsConfirm() {
    this.setState({ resetDefaultWeightsOpen: true });
  }

  exitResetDefaultWeightsModal() {
    this.setState({ resetDefaultWeightsOpen: false });
  }

  renderKrWeightModalFooter = () => {
    const { t } = this.props;
    const showResetToDefaults = isKrWeightResetToDefaultsVisible(this.props.goalDetails);
    return (
      <div className="kr-weight-modal-footer">
        {showResetToDefaults && (
          <Button
            variant="ghost"
            type="button"
            className="kr-weight-modal-footer__reset"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              this.openResetDefaultWeightsConfirm();
            }}
          >
            {t('Reset to default weights')}
          </Button>
        )}
        <div className="kr-weight-modal-footer__right">
          <Button
            variant="ghost"
            type="button"
            onClick={(e) => {
              e.preventDefault();
              this.cancelWeightKr();
            }}
          >
            {t('Cancel')}
          </Button>
          <Button
            variant="primary"
            type="button"
            disabled={!this.canSaveKrWeights()}
            onClick={(e) => {
              e.preventDefault();
              this.saveWeightKr(e);
            }}
          >
            {t('Save')}
          </Button>
        </div>
      </div>
    );
  };

  confirmResetDefaultWeights() {
    const { actions } = this.props;
    const goalId = this.props.goalDetails.id;
    reactLoader();
    const that = this;
    this.GoalServices.resetKrWeightingToDefaults({ goalId })
      .then(function (response) {
        removeReactLoader();
        that.exitResetDefaultWeightsModal();
        if (
          response &&
          response.data &&
          response.data.status === 'success' &&
          response.data.data &&
          Object.keys(response.data.data).length
        ) {
          actions.updateEditedOkr({ data: response.data.data });
          that.setState({
            isWeightOpen: false,
            krWeightSaveAttempted: false,
            krWeightValidationErrors: [],
            krWeightage: {},
          });
          try {
            const channel = new BroadcastChannel('okr:objectiveUpdated');
            channel.postMessage(goalId);
          } catch (e) {
            /* ignore */
          }
        }
      })
      .catch(function () {
        removeReactLoader();
        that.exitResetDefaultWeightsModal();
      });
  }

  saveWeightKr(e){
    if (!isKrWeightEditorVisible(this.props.goalDetails)) {
      return
    }
		const { actions, t } = this.props;
		let goal_id = this.props.addOkrData.goalDetails.id
		e.preventDefault();
    if (!this.canSaveKrWeights()) {
      return;
    }
    const validationErrors = this.collectKrWeightSaveValidationErrors()
    this.setState({
      krWeightSaveAttempted: true,
      krWeightValidationErrors: validationErrors,
    })
    if (validationErrors.length > 0) {
      return
    }
		let param = {};
		var demo = {};
    const item = this.props.goalDetails.metrics;
		var {krWeightage} = this.state;
		item.map((i, key) => {
			let obj = {}
			obj.id = i.id;
      const raw = krWeightage[i.id]?.percent
      let mult = 0
      if (raw !== '' && raw != null && typeof raw !== 'undefined') {
        const n = parseFloat(String(raw))
        if (Number.isFinite(n)) {
          mult = n
        }
      }
      obj.multiplier = mult
			demo[key] = obj;
		});
		param.metrics = demo ;
		param.goalId = goal_id ;
		let that = this;
		reactLoader();
		actions.updateKrWeight(demo);
		that.GoalServices.saveKRweightage(param)
			.then(function (response) {
				var saveOk =
					response &&
					response.data &&
					response.data.status === 'success' &&
					response.data.data != null &&
					Object.keys(response.data.data).length;
				if (!saveOk) {
					removeReactLoader();
					const errMsg =
						(response && response.data && response.data.data && response.data.data.error)
						|| (response && response.data && response.data.error)
						|| t('Unable to save key result weights.');
					that.setState({
						krWeightSaveAttempted: true,
						krWeightValidationErrors: [errMsg],
					});
					return;
				}
				that.GoalServices.editKr({ goalId: goal_id })
					.then(function (refreshResponse) {
						var goalDetails =
							refreshResponse &&
							(refreshResponse.data && refreshResponse.data.goalDetails
								? refreshResponse.data.goalDetails
								: refreshResponse.data &&
										refreshResponse.data.data &&
										refreshResponse.data.data.goalDetails
									? refreshResponse.data.data.goalDetails
									: null);
						if (goalDetails && Object.keys(goalDetails).length) {
							actions.updateEditedOkr({ data: goalDetails });
						}
					})
					.catch(function () {
						/* ignore refresh failure; save already succeeded */
					})
					.then(function () {
						removeReactLoader();
						that.cancelWeightKr(that.props, 'save');
					});
			})
			.catch(function (err) {
				removeReactLoader();
				const errMsg =
					(err && err.response && err.response.data && err.response.data.data && err.response.data.data.error)
					|| (err && err.response && err.response.data && err.response.data.error)
					|| t('Unable to save key result weights.');
				that.setState({
					krWeightSaveAttempted: true,
					krWeightValidationErrors: [errMsg],
				});
			});
  }
  // function to reorder the result
  reorder(list, startIndex, endIndex) {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  }

  onDragEnd(result) {
    this.handleDragTitle(false)
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const items = this.reorder(
      this.props.goalDetails.metrics,
      result.source.index,
      result.destination.index
    );

    let { actions } = this.props;
    actions.reorderMetrics(items);

    let goalId = this.props.goalDetails.id;
    let reOrderedItems = [];

    if (items.length > 0) {
      items.map(function(item) {
        reOrderedItems.push(item.id);
      });
    }

    this.GoalServices.saveMetricOrder({
      id: goalId,
      items: reOrderedItems
    }).then(response => {});
  }

  getSymbol(metricType) {
    let textMetric = "";
    if (metricType == 1) {
      textMetric = "";
    } else if (metricType == 2) {
      textMetric = "";
    } else if (metricType == 3) {
      textMetric = "%";
    }
    return textMetric;
  }

  returnNumberSuffix(number) {
    if (number == "" || number == null || number == "undefined" || isNaN(number)) {
      return 0;
    }
    return formatNumber(number);
  }

  metadataForLinkText(kr) {
    let metrics = kr.metricMirror.length ? kr.metricMirror[0] : kr;
    const { t } = this.props;
    let first = "";
    let second = "";
    let achieveTarget =
      (metrics.achieve_target == "" || metrics.achieve_target == null
        ? 0
        : this.returnNumberSuffix(Number(metrics.achieve_target))) +
      this.getSymbol(metrics.metric);
    let onlyTarget =
      (metrics.target == "" || metrics.target == null
        ? " of  " + 0
        : " of  " + this.returnNumberSuffix(Number(metrics.target))) +
      this.getSymbol(metrics.metric);
    if (this.state.isStretchEnabled) {
      onlyTarget = onlyTarget +
      (metrics.stretch_target == "" || metrics.stretch_target == null
        ? ""
        : " -  " + this.returnNumberSuffix(Number(metrics.stretch_target))
      )
    }
    first =
      metrics.counting == 4 &&
      metrics.lower_limit &&
      achieveTarget +
        " of " +
        this.returnNumberSuffix(Number(metrics.lower_limit)) +
        " - ";
    second =
      metrics.counting == 4 &&
      metrics.upper_limit &&
      this.returnNumberSuffix(Number(metrics.upper_limit));
    if ((metrics.source == 3 || 1) && metrics.type == 2) {
      return (
        <div className="krinfo inLineBlk verticalTop">
          {t('Cascaded participants to update')} {this.metricText(metrics.metric)}{" "}
          {this.intervalText(
            metrics.interval == null ? 0 : metrics.interval,
            metrics.weekly_update_day == null ? 0 : metrics.weekly_update_day
          )}{" "}
          <span className="dotClass"></span> {metrics.achieveTargetText}
          {" of "}
          {metrics.totalTargetText}
        </div>
      );
    } else if (metrics.source == 1) {
      return (
        <div className="krinfo inLineBlk verticalTop">
          {metrics.metricOwnerName.length > 30
            ? metrics.metricOwnerName.substr(0, 30) + "..."
            : metrics.metricOwnerName}{" "}
          {t('to update')} {this.metricText(metrics.metric)}{" "}
          {this.intervalText(
            metrics.interval == null ? 0 : metrics.interval,
            metrics.weekly_update_day == null ? 0 : metrics.weekly_update_day
          )}{" "}
          <span className="dotClass"></span> {metrics.achieveTargetText}
          {" of "}
          {metrics.totalTargetText}
        </div>
      );
    } else if (metrics.source == 5) {
      if (metrics.counting == 6) {
        return (
          <div className="krinfo inLineBlk verticalTop">
            {t('Group of participants to update')} {this.metricText(metrics.metric)}{" "}
            {this.intervalText(
              metrics.interval == null ? 0 : metrics.interval,
              metrics.weekly_update_day == null ? 0 : metrics.weekly_update_day
            )}{" "}
            <span className="dotClass"></span> {metrics.achieveTargetText}
            {t(" of ")}
            {metrics.totalTargetText}
          </div>
        );
      } else {
        return (
          <div className="krinfo inLineBlk verticalTop">
            {t('Group of participants to update')} {this.metricText(metrics.metric)}{" "}
            {this.intervalText(
              metrics.interval == null ? 0 : metrics.interval,
              metrics.weekly_update_day == null ? 0 : metrics.weekly_update_day
            )}{" "}
            <span className="dotClass"></span> {metrics.achieveTargetText}
            {t(" of ")}
            {metrics.totalTargetText}
          </div>
        );
      }
    } else if (metrics.source == 10) {
      return (
        <div className="krinfo inLineBlk verticalTop">
          {t('Sourcing data from DATA STREAM')} <span className="dotClass"></span>{" "}
          {metrics.achieveTargetText}
          {t(" of ")}
          {metrics.totalTargetText}
        </div>
      );
    } else if (metrics.source == 8) {
      let textRendered = "";
      if (metrics.ext_app_id) {
        textRendered = getKpiExternalAppDisplayNameById(metrics.ext_app_id);
      }
      if (
        metrics.achieve_target == "" ||
        metrics.achieve_target == null ||
        metrics.achieve_target == "0" ||
        (metrics.target == "" ||
          metrics.target == null ||
          metrics.target == "0")
      ) {
        return (
          <div className="krinfo inLineBlk verticalTop">
            {t('Sourcing data from')} {textRendered} - {t('Collecting data')}...
          </div>
        );
      } else {
        return (
          <div className="krinfo inLineBlk verticalTop">
            {t('Sourcing data from')} {textRendered} <span className="dotClass"></span>{" "}
            {metrics.achieveTargetText}
            {t(" of ")}
            {metrics.totalTargetText}
          </div>
        );
      }
    } else if (metrics.source == 3) {
      return (
        <div className="krinfo inLineBlk verticalTop" data-testid="info_Rolling_up">
          {t('Rolling up Key Results')} <span className="dotClass"></span>{" "}
          {metrics.achieveTargetText}
          {t(" of ")}
          {metrics.totalTargetText}
        </div>
      );
    } else if (metrics.source == 7) {
      return (
        <div className="krinfo inLineBlk verticalTop" data-testid="info_Rolling_up">
          {t('Rolling up other objectives')} <span className="dotClass"></span>{" "}
          {metrics.achieveTargetText}
          {t(" of ")}
          {metrics.totalTargetText}
        </div>
      );
    } else if (metrics.source == 12 || metrics.source == 14) {
      return (
        <div className="krinfo inLineBlk verticalTop">
          {t('Multiple targets')} |{" "}
          {metrics.owner_fullname.length > 30
            ? metrics.owner_fullname.substr(0, 30) + "..."
            : metrics.owner_fullname}{" "}
          {t('to update')} {this.metricText(metrics.metric)}{" "}
          {this.intervalText(
            metrics.interval == null ? 0 : metrics.interval,
            metrics.weekly_update_day == null ? 0 : metrics.weekly_update_day
          )}{" "}
          <span className="dotClass"></span> {metrics.achieveTargetText}{" "}
          {onlyTarget}
        </div>
      );
    } else if (metrics.source == 13) {
      return (
        <div className="krinfo inLineBlk verticalTop">
          {t('Multiple targets')} | {t('Sourcing data from DATA STREAM')}{" "}
          <span className="dotClass"></span>{" "}
          {first != "" ? first : metrics.achieveTargetText}
          {second != "" ? second : onlyTarget}
        </div>
      );
    } else if (metrics.source == 11) {
      return (
        <div className="krinfo inLineBlk verticalTop" data-testid="info_Rolling_up">
          {t('Rolling up other objectives to update')}{" "}
          {this.metricText(metrics.metric)}{" "}
          {this.intervalText(
            metrics.interval == null ? 0 : metrics.interval,
            metrics.weekly_update_day == null ? 0 : metrics.weekly_update_day
          )}{" "}
          <span className="dotClass"></span>
          {metrics.achieveTargetText}
          {t(" of ")}
          {metrics.totalTargetText}
        </div>
      );
    } else if (metrics.source == 2) {
      return (
        <div className="krinfo inLineBlk verticalTop">
          {t('Measuring workstream activity for completion percentage')}{" "}
          <span className="dotClass"></span>
          {metrics.achieveTargetText}{" "}
          {metrics.metric == 4 ? " of " + metrics.totalTargetText : ""}
        </div>
      );
    }
  }

  metadataText(metrics) {
    const { t } = this.props;
    let first = "";
    let second = "";
    let achieveTarget =
      (metrics.achieve_target == "" || metrics.achieve_target == null
        ? 0
        : this.returnNumberSuffix(Number(metrics.achieve_target))) +
      this.getSymbol(metrics.metric);
    let onlyTarget =
      (metrics.target == "" || metrics.target == null
        ? ` ${t('of')}  ` + 0
        : ` ${t('of')}  ` + this.returnNumberSuffix(Number(metrics.target))) +
      this.getSymbol(metrics.metric);
    if (this.state.isStretchEnabled) {
      onlyTarget = onlyTarget + (metrics.stretch_target == "" || metrics.stretch_target == null
        ? ""
        : " -  " + this.returnNumberSuffix(Number(metrics.stretch_target)) +
        this.getSymbol(metrics.metric))
    }
    first =
      metrics.counting == 4 &&
      metrics.lower_limit &&
      achieveTarget +
        ` ${t('of')} ` +
        this.returnNumberSuffix(Number(metrics.lower_limit)) +
        " - ";
    second =
      metrics.counting == 4 &&
      metrics.upper_limit &&
      this.returnNumberSuffix(Number(metrics.upper_limit));
    if (metrics.source == 5) {
      achieveTarget =
        (metrics.achieve_target == "" || metrics.achieve_target == null
          ? 0
          : this.returnNumberSuffix(Number(metrics.achieve_target))) +
        this.getSymbol(metrics.metric);
      onlyTarget =
        (metrics.target == "" || metrics.target == null
          ? ` ${t('of')}  ` + 0
          : ` ${t('of')}  ` + this.returnNumberSuffix(Number(metrics.target))) +
        this.getSymbol(metrics.metric);
      if (
        metrics.measure_metric_data == 3 ||
        metrics.measure_metric_data == 4
      ) {
        achieveTarget = achieveTarget + "%";
        onlyTarget = onlyTarget + "%";
      } else {
        achieveTarget = achieveTarget;
        onlyTarget = onlyTarget;
      }
      if (this.state.isStretchEnabled) {
        onlyTarget = onlyTarget + (metrics.stretch_target == "" || metrics.stretch_target == null
          ? ""
          : " -  " + this.returnNumberSuffix(Number(metrics.stretch_target)))
        if (metrics.measure_metric_data == 3 ||
            metrics.measure_metric_data == 4) {
            onlyTarget = onlyTarget + "%";
        }
      }
      first =
        metrics.counting == 6 &&
        metrics.lower_limit &&
        achieveTarget +
          ` ${t('of')} ` +
          this.returnNumberSuffix(Number(metrics.lower_limit)) +
          " - ";
      second =
        metrics.counting == 6 &&
        metrics.upper_limit &&
        this.returnNumberSuffix(Number(metrics.upper_limit));
    }
    if ((metrics.source == 3 || 1) && metrics.type == 2) {
      return (
        <div className="krinfo inLineBlk verticalTop">
          {t('Cascaded participants to update')} {this.metricText(metrics.metric)}{" "}
          {this.intervalText(
            metrics.interval == null ? 0 : metrics.interval,
            metrics.weekly_update_day == null ? 0 : metrics.weekly_update_day
          )}{" "}
          <span className="dotClass"></span>{" "}
          {first != "" ? first : achieveTarget}
          {second != "" ? second : onlyTarget}
        </div>
      );
    } else if (metrics.source == 1) {
      return (
        <div className="krinfo inLineBlk verticalTop">
          {metrics.owner_fullname.length > 30
            ? metrics.owner_fullname.substr(0, 30) + "..."
            : metrics.owner_fullname}{" "}
          {t('to update')} {this.metricText(metrics.metric)}{" "}
          {this.intervalText(
            metrics.interval == null ? 0 : metrics.interval,
            metrics.weekly_update_day == null ? 0 : metrics.weekly_update_day
          )}{" "}
          <span className="dotClass"></span>{" "}
          {first != "" ? first : achieveTarget}
          {second != "" ? second : onlyTarget}
        </div>
      );
    } else if (metrics.source == 5) {
      if (metrics.counting == 6) {
        return (
          <div className="krinfo inLineBlk verticalTop">
            {t('Group of participants to update')} {this.metricText(metrics.metric)}{" "}
            {this.intervalText(
              metrics.interval == null ? 0 : metrics.interval,
              metrics.weekly_update_day == null ? 0 : metrics.weekly_update_day
            )}{" "}
            <span className="dotClass"></span>{" "}
            {first != "" ? first : achieveTarget}
            {second != "" ? second : onlyTarget}
          </div>
        );
      } else {
        return (
          <div className="krinfo inLineBlk verticalTop">
            {t('Group of participants to update')} {this.metricText(metrics.metric)}{" "}
            {this.intervalText(
              metrics.interval == null ? 0 : metrics.interval,
              metrics.weekly_update_day == null ? 0 : metrics.weekly_update_day
            )}{" "}
            <span className="dotClass"></span>{" "}
            {first != "" ? first : achieveTarget}
            {second != "" ? second : onlyTarget}
          </div>
        );
      }
    } else if (metrics.source == 10) {
      return (
        <div className="krinfo inLineBlk verticalTop">
          {t('Sourcing data from DATA STREAM')} <span className="dotClass"></span>{" "}
          {first != "" ? first : achieveTarget}
          {second != "" ? second : onlyTarget}
        </div>
      );
    } else if (metrics.source == 8) {
      let textRendered = "",
        textRenderedVal = "";
      textRenderedVal =
        metrics.achieve_target == "" || metrics.achieve_target == null
          ? 0
          : this.returnNumberSuffix(Number(metrics.achieve_target));
      textRenderedVal =
        textRenderedVal +
        this.getSymbol(metrics.metric) +
        " of " +
        (metrics.target == null
          ? 0
          : this.returnNumberSuffix(Number(metrics.target)));
      textRenderedVal = textRenderedVal + this.getSymbol(metrics.metric);

      if (metrics.ext_app_id) {
        if (metrics.ext_app_id == 5) {
          textRendered = "JIRA";
          textRenderedVal = metrics.achieve_target;
          if (metrics.metric == 3 || (metrics.metricJira && metrics.metricJira.qtype != "jql")) {
            textRenderedVal = metrics.progress + "%";
          }
        } else if (metrics.ext_app_id == Constants.MONDAY_KPI_ID && metrics.metric == 3) {
          textRendered = "Monday";
          let numProgress = parseFloat(metrics.progress);
          if (isNaN(numProgress) || numProgress == "0" || numProgress === '' || numProgress === null) {
            numProgress  = (parseFloat(metrics.achieve_target)/ parseFloat(metrics.target)) * 100;
          }
          textRenderedVal = Number.isInteger(numProgress)
            ? `${numProgress}%`
            : `${numProgress.toFixed(2)}%`;
        } else if (metrics.ext_app_id == Constants.AZURE_DEVOPS_KPI_ID && metrics.metric == 3) {
          textRendered = "Azure DevOps";
          let numProgress = parseFloat(metrics.progress);
          if (isNaN(numProgress) || numProgress == "0" || numProgress === '' || numProgress === null) {
            numProgress  = (parseFloat(metrics.achieve_target)/ parseFloat(metrics.target)) * 100;
          }
          textRenderedVal = Number.isInteger(numProgress)
            ? `${numProgress}%`
            : `${numProgress.toFixed(2)}%`;
        } else if (metrics.ext_app_id == Constants.WRIKE_KPI_ID && metrics.metric == 3) {
          textRendered = "Wrike";
          let numProgress = parseFloat(metrics.progress);
          if (isNaN(numProgress) || numProgress == "0" || numProgress === '' || numProgress === null) {
            numProgress  = (parseFloat(metrics.achieve_target)/ parseFloat(metrics.target)) * 100;
          }
          textRenderedVal = Number.isInteger(numProgress)
            ? `${numProgress}%`
            : `${numProgress.toFixed(2)}%`;
        } else {
          textRendered = getKpiExternalAppDisplayNameById(metrics.ext_app_id);
        }
      }
      if (
        metrics.achieve_target == "" ||
        metrics.achieve_target == null ||
        metrics.achieve_target == "0" ||
        (metrics.target == "" ||
          metrics.target == null ||
          metrics.target == "0")
      ) {
        return (
          <div className="krinfo inLineBlk verticalTop">
            {t('Sourcing data from')} {textRendered} - {t('Collecting data')}...
          </div>
        );
      } else {
        return (
          <div className="krinfo inLineBlk verticalTop">
            {t('Sourcing data from')} {textRendered} <span className="dotClass"></span>{" "}
            {textRenderedVal}
          </div>
        );
      }
    } else if (metrics.source == 3) {
      // if(metrics.metricMetric.length == 1 && metrics.metricMetric[0].source == 2 && metrics.metricMetric[0].metric == 3){
      //   achieveTarget = metrics.metricMetric[0].achieve_target;
      // }
      if(metrics.metricMetric && metrics.metricMetric.length && metrics.metricMetric[0].source == 2) {
        onlyTarget = '';
      }
      return (
        <div className="krinfo inLineBlk verticalTop" data-testid="info_Rolling_up" >
          {t('Rolling up Key Results')} <span className="dotClass"></span>{" "}
          {achieveTarget} {onlyTarget}
        </div>
      );
    } else if (metrics.source == 7) {
      return (
        <div className="krinfo inLineBlk verticalTop" data-testid="info_Rolling_up">
          {t('Rolling up other objectives')} <span className="dotClass"></span>{" "}
          {achieveTarget}
          {this.getSymbol(3)} {onlyTarget}
          {this.getSymbol(3)}
        </div>
      );
    } else if (metrics.source == 12 || metrics.source == 14) {
      return (
        <div className="krinfo inLineBlk verticalTop">
          {t('Multiple targets')} |{" "}
          {metrics.owner_fullname.length > 30
            ? metrics.owner_fullname.substr(0, 30) + "..."
            : metrics.owner_fullname}{" "}
          {t('to update')} {this.metricText(metrics.metric)}{" "}
          {this.intervalText(
            metrics.interval == null ? 0 : metrics.interval,
            metrics.weekly_update_day == null ? 0 : metrics.weekly_update_day
          )}{" "}
          <span className="dotClass"></span> {achieveTarget} {onlyTarget}
        </div>
      );
    } else if (metrics.source == 13) {
      return (
        <div className="krinfo inLineBlk verticalTop">
          {t('Multiple targets')} | {t('Sourcing data from DATA STREAM')}{" "}
          <span className="dotClass"></span>{" "}
          {first != "" ? first : achieveTarget}
          {second != "" ? second : onlyTarget}
        </div>
      );
    } else if (metrics.source == 11) {
      return (
        <div className="krinfo inLineBlk verticalTop" data-testid="info_Rolling_up">
          {t('Rolling up other objectives to update')}{" "}
          {this.metricText(metrics.metric)}{" "}
          {this.intervalText(
            metrics.interval == null ? 0 : metrics.interval,
            metrics.weekly_update_day == null ? 0 : metrics.weekly_update_day
          )}{" "}
          <span className="dotClass"></span>{" "}
          {metrics.achieve_target == null ? 0 : metrics.achieve_target}
          {this.getSymbol(metrics.metric)} of {metrics.target}
          {this.getSymbol(metrics.metric)}
        </div>
      );
    } else if (metrics.source == 2) {
      let _achieveTarget = "";
      let _totalTarget =
        metrics.metric == 3
          ? (typeof metrics.total_target === "undefined"
              ? metrics.target
              : metrics.total_target) + "%"
          : typeof metrics.total_target === "undefined"
          ? metrics.target
          : metrics.total_target;
      if (metrics.achieve_target == -1) {
        _achieveTarget = "--";
      } else {
        _achieveTarget =
          metrics.metric == 3
            ? metrics.achieve_target + "%"
            : metrics.achieve_target;
      }
      if (metrics.metric == 3) {
        const metricProgress = metrics.progress == null ? 0 : metrics.progress;
        _achieveTarget = metricProgress != -1 ? metricProgress + "%" : "--";
      }
      return (
        <div className="krinfo inLineBlk verticalTop">
          {t('Measuring workstream activity for completion percentage')}{" "}
          <span className="dotClass"></span>
          {_achieveTarget} {metrics.metric == 4 ? " of " + _totalTarget : ""}
        </div>
      );
    }
  }

  addAnotherkr() {
    this.setState({
      setKr: true,
      krTextField: true,
      addNotherKr: false,
      advancedOptionEn: true,
      advanceOptionEn: true,
      addKrFinished: false
    });
    // IE Placeholder
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
      setTimeout(function() {
        $(".basicTextplace").placeHolder();
      }, 10);
    }
  }

  updateAllStates = () => {
    this.setState({
      krListEn: true,
      // addNotherKr: true,
      ErrorDis: false,
      btnState: false,
      setKr: true,
      advanceOptionEn: true,
      addKrValue: "",
      krNameText: "",
      deleteKrList: false,
      deleteKrId: "",
      krTextField:
        this.props.goalDetails &&
        this.props.goalDetails.metrics !== undefined &&
        Object.keys(this.props.goalDetails.metrics).length > 0
          ? false
          : true,
      addKrFinished: false,
      addNotherKr:
        this.props.goalDetails &&
        this.props.goalDetails.metrics !== undefined &&
        Object.keys(this.props.goalDetails.metrics).length > 0
          ? true
          : false
    });
    $(".basicTextplace").val("");
    let krtext = "";
    this.props.krTextWithOutsave(krtext);
    if (this.state.krRightPaneDelete) {
      ReactDOM.unmountComponentAtNode(document.getElementById("mySidenas"));
    }
  }

  getSourceIconClass(metricObj)
  {
    const { source, ext_app_id, type } = metricObj;
    let iconClass = null;

    if (ext_app_id) {
      iconClass = getExternalAppIconClass(ext_app_id);
    }

    if (iconClass == null) {
      iconClass = (source) ? `metricIcon_${(type == 2 ? 9 : (source == 14 ? 12 : source))}` : 'basickrIcon';
    }
    return iconClass;
  }

  handleDragTitle = (isDragOn) => {
    const ariaDesc = document.activeElement.attributes['aria-describedby']?.value
    const ariaDescArr = ariaDesc?.split(" ")
    if(isDragOn) {
      if(ariaDescArr) {
        // `a?.b = c` is not legal JS — optional chaining cannot be an assignment target.
        // swc rejects it outright; the old toolchain let it through.
        const ariaDescEl = document.getElementById(ariaDescArr[1]);
        if (ariaDescEl?.style) {
          ariaDescEl.style.display = 'none';
        }
      }
    } else {
      document.activeElement.blur()
    }
  }

    getTeamOptions = async () => {
      const response = await this.GoalServices.searchTeamName({
        term: '',
        offset: 0,
        limit: 100
      });
      this.setState({
        teamOptions: response.data ?? [],
      })
    }
    getTimePeriodOptions = async () => {
      const goalType = this.props.addOkrData.goalDetails.type;
      const response = await this.GoalServices.addEditObjective({
        goal: {
          type: goalType,
          saveData: 0,
        },
      });
      this.setState({
        timePeriodOptions: response.data?.data?.filterOption ?? [],
      })
    }

  handleCoauthorClick = (e, value, portalNode, originator, placement = "bottom-start") => {
    const { goal, metrics } = this.props.goalDetails;
    const teamOptions = this.state.teamOptions;
    const timePeriodOptions = this.state.timePeriodOptions;
    window.openOkrCoauthor({
      type: "OPEN_KR_CHAT",
      initialDraft: value,
      anchor: e.target,
      placement,
      config: {
        team: teamOptions[0],
        timePeriod: timePeriodOptions[0],
        ...getCoauthorConfig(this.props.goalDetails, this.props.goalType)
      },
      originator,
      initialDraftOKR: {
        objective: goal,
        keyResults: metrics?.map(m => m.name) ?? []
      },
      teamOptions,
      timePeriodOptions,
    }, portalNode);
  }

  render() {
    const { t, actions } = this.props;
    const { display_kr_clustering, display_nested_kr, isEnabledBiweeklyKR = false } = this.props.addOkrData;
    return (
      <div className="kREmptyArea krspacealignment">
        <ThemeProvider>
        <DragDropContext
          onDragStart={() => this.handleDragTitle(true)}
          onDragEnd={this.onDragEnd}
        >
          <Droppable droppableId="droppable">
            {(provided, snapshot) => (
              <div ref={provided.innerRef}>
                <div className="">
                  <div className="krHeadText" tabIndex={-1} id={"krHeadTextId"} role="heading" aria-level="2">{t('KEY RESULTS')} </div>
                  {this.state.krListEn &&
                    isKrWeightEditorVisible(this.props.goalDetails) && (
                      <>
                          <Button
                            kind="normal"
                            onClick={e => this.weightKr()}
                            variant="ghost"
                            className="changeWeightsBtn"
                          >
                            {t('Change weights')}{" "}
                          </Button>

                          <StyledModal
                            $weightModalZIndex={getKrWeightModalZIndex()}
                            className="portal-modal-aEmodal modal-backdrop-aEmodal aEWeightmodal"
                            title={`${t('Edit Key Result Weighting')}`}
                            isOpen={
                              this.state.isWeightOpen &&
                              !this.state.resetDefaultWeightsOpen
                            }
                            id="kr-weightage-modal"
                            onDismiss={() => this.cancelWeightKr()}
                            onSubmit={(e) => {
                              e.preventDefault();
                              if (!this.canSaveKrWeights()) {
                                return;
                              }
                              this.saveWeightKr(e);
                            }}
                            actions={this.renderKrWeightModalFooter}
                            disableScrollLock
                          >
                            <KrWeighting
                              {...this.props}
                              item={this.props.goalDetails.metrics}
                              krWeightage={this.state.krWeightage}
                              isKrMultiperAlter={this.props.goalDetails.isKrMultiperAlter}
                              krWeightCal={this.krWeightPercentChange}
                              krWeightSaveAttempted={this.state.krWeightSaveAttempted}
                              krWeightValidationErrors={this.state.krWeightValidationErrors}
                            />
                          </StyledModal>
                      </>
                    )}
                </div>
                {this.state.krListEn &&
                  this.props.goalDetails.metrics &&
                  this.props.goalDetails.metrics.length > 0 && (
                    <div className="krListSec" role="list" id="krListSecId">
                      {this.props.goalDetails.metrics.map((metric, index) => (
                        metric.goal_id!==null &&
                        <Draggable
                          key={metric.id}
                          draggableId={metric.id}
                          index={index}
                        >
                          {(provided, snapshot) => (
                            <div
                            role="listitem"
                              className="kritems"
                              key={metric.id}
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              onMouseEnter={event => {
                                this.setState({ showDragIcon: metric.id });
                              }}
                              onMouseLeave={event => {
                                this.setState({ showDragIcon: "" });
                              }}
                              onFocus={(e) => this.setState({ showDragIcon: metric.id })}
                              onBlur={(e) => this.setState({ showDragIcon: "" })}
                            >
                              <div
                                title={t("Drag and Drop")}
                                aria-label= {`Drag and Drop ${index + 1} of ${this.props.goalDetails.metrics.length} ${metric.name}`}
                                className={
                                  this.state.showDragIcon == metric.id
                                    ? "krDrag krDragDiv"
                                    : "krDragDiv"
                                }
                                {...provided.dragHandleProps}
                              ></div>
                              <div className="krNameDiv inLineBlk">
                                { this.getSourceIconClass(metric) ?
                                    <div className={`inLineBlk verticalTop metricIconExternalApp ${this.getSourceIconClass(metric)}`}></div>
                                    :
                                    (<div className={`inlineBlk verticalTop metricIconExternalApp`}><img src={getExternalAppIconDataUri(metric.ext_app_id)}/></div>)
                                }
                                <div className="krEditSaveDiv">
                                <div tabIndex={-1} id={"krNameEmpty_"+index} className="screen-reader-only" style={{outline:"0px !important"}} />
                                {this.state.krEditId == metric.id ? (
                                  <InlineKrEditComp
                                    krkeys={metric.id}
                                    metricEdit={metric.name}
                                    handleSaveKrChange={this.handleSaveKrChange}
                                    isKeyResult={true}
                                    labelText={t("Write a key result to measure the success of your objective")}
                                  />
                                ) : (
                                  <div
                                    tabIndex={0}
                                    role="textbox"
                                    aria-label={t("Key Results Use enter or spacebar to activate text area")}
                                    className={"krNamesList krListNames inLineBlk wordWrapForText " + ((metric.source != 11 ) ? ' editicon ' : '')}
                                    id={"krEditSaveid_"+index}
                                    value={metric.id}
                                    onClick={() =>
                                      this.handleDoubleClickItem(
                                        metric.id,
                                        metric
                                      )
                                    }
                                    onKeyDown={e => KeyDownEvent(e, () => {
                                      this.handleDoubleClickItem(metric.id, metric)
                                    })}
                                  >
                                    <span id={"krEditBtnLbl_"+index}>{metric.name}</span>
                                  </div>
                                )}
                             {metric.source == 11 ? (
                                <div className="krBasicInfo">
                                  {this.metadataForLinkText(metric)}
                                  <div className="inLineBlk krInlineSaveDiv">
                                    {this.state.krEditId == metric.id && (
                                      <span>
                                        <div
                                           tabIndex={0}
                                           role="button"
                                           aria-label={t("Cancel")}
                                          className="krInlineCancel inLineBlk"
                                          value={metric.id}
                                          onClick={() => this.UpdateKrName(null,null,index)}
                                          onKeyDown={e => KeyDownEvent(e, () => {
                                            this.UpdateKrName(null,null,index);
                                          })}
                                        ></div>
                                        <div
                                          tabIndex={0}
                                          role="button"
                                          aria-label={t("Submit")}
                                          className="krInlineSave inLineBlk"
                                          onClick={() =>{
                                            this.UpdateKrName(metric.id, metric,index)
                                          }
                                          }
                                          onKeyDown={e => KeyDownEvent(e, () => {
                                            this.UpdateKrName(metric.id, metric,index);
                                          })}
                                        ></div>
                                      </span>
                                    )}
                                  </div>
                                </div>
                              ) : (
                                <div className="krBasicInfo">
                                  {this.metadataText(metric)}
                                  <div className="inLineBlk krInlineSaveDiv">
                                    {this.state.krEditId == metric.id && (
                                      <span>
                                        <div
                                          tabIndex={0}
                                          role="button"
                                          aria-label={t("Cancel")}
                                          className="krInlineCancel inLineBlk"
                                          value={metric.id}
                                          onClick={() => this.UpdateKrName(null,null,index)}
                                          onKeyDown={e => KeyDownEvent(e, () => {
                                            this.UpdateKrName(null,null,index);
                                          })}
                                        ></div>
                                        <div
                                          tabIndex={0}
                                          role="button"
                                          aria-label={t("Submit")}
                                          className="krInlineSave inLineBlk"
                                          onClick={() =>{
                                            this.UpdateKrName(metric.id, metric,index)
                                          }
                                          }
                                          onKeyDown={e => KeyDownEvent(e, () => {
                                            this.UpdateKrName(metric.id, metric,index);
                                          })}
                                        ></div>
                                      </span>
                                    )}
                                  </div>
                                </div>
                              )}
                            </div>
                            <div className="krEditdelBtns">
                            <div className="krEditdelBtnsWrapper">
                              <span style={{minWidth: '43px'}}>
                                {
                                  display_kr_clustering && metric.clusterCount > 0 && metric.source != 11 && <KrCluster
                                      arrowClass='centerAligned'
                                      iconClass='iconClass'
                                      popupClass='clusterCenter'
                                      updateKRStates={this.updateAllStates}
                                      metric={metric}
                                      actions={actions}
                                      />
                                }
                              </span>
                               <div
                                  role="button"
                                  tabIndex={0}
                                  aria-label={t("Edit")}
                                  aria-describedby={"krEditBtnLbl_"+index}
                                  className="editKrIcon inLineBlk"
                                  data-testid="editKrIcon"
                                  onClick={e => this.editKrItem(e, metric)}
                                  onKeyDown={e => KeyDownEvent(e, () => {
                                    this.editKrItem(e, metric);
                                  })}
                                ></div>
                                <CoauthorButtonWithPortal variant="icon" onClick={(e, portalNode) => this.handleCoauthorClick(e, metric.name, portalNode, { id: TEXTAREA_IDS.inlineEdit, type: 'kr', krSlotIndex: index }, 'bottom-end')} />
                                <div
                                  tabIndex={0}
                                  role="button"
                                  aria-label={t("Delete Key Result")}
                                  className="deleteKrIcon inLineBlk verticalTop"
                                  onClick={() => this.deleteMetric(metric.id)}
                                  onKeyDown={e => KeyDownEvent(e, () => {
                                    this.deleteMetric(metric.id);
                                  })}
                                  data-testid="deleteKrIcon"
                                ></div>
                                 {
                                  isKrWeightEditorVisible(this.props.goalDetails) && (
                                  <div className="krWeight inLineBlk verticalTop">
                                    {isMetricCountedForKrWeighting(metric) &&
                                    metric.weightage !== null &&
                                    metric.weightage !== undefined &&
                                    metric.weightage !== '' &&
                                    !Number.isNaN(
                                      Number(String(metric.weightage).replace(/%$/, '').trim())
                                    )
                                      ? `${formatKrSharePercentDisplay(krSharePercentFromStoredWeightage(metric.weightage, sumIncludedMetricsWeightage(this.props.goalDetails.metrics)))}%`
                                      : ''}
                                  </div>
                                )}
                                </div>
                              </div>
                              </div>
                              </div>
                          )}
                        </Draggable>
                      ))}
                    </div>
                  )}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
        <div id="krWeights"></div>
        {this.state.addNotherKr && (
          <div className="newKrAdd" data-testid="newKrAdd">
            <Button
                kind="normal"
                onClick={e => this.addAnotherkr()}
                variant="ghost"
                data-testid="add-another-kr"
                className="add-another-key-result"
                startIcon={
                  <i className="icon icon-outline-add_circle_outline-24px-blue ">
                  </i>}
            >
              {t('Add another key result')}
            </Button>
          </div>
        )}
        </ThemeProvider>
        {this.state.krTextField && (
          <div className="RectangleKrLeft">
            <div className="marginTop29"></div>
            {this.state.setKr && (
              <div className="krEmpty ">
                <label className="krLabelName" id="krNameEmpty">{t('Key result name')}</label>
                <textarea
                  key={this.getKey()}
                  className="basicTextplace"
                  ref={node => (this.getTextFocus = node)}
                  placeholder={t('Write a key result to measure the success of your objective, then press enter')}
                  onChange={this.handleKrChange}
                  onKeyDown={event => this.onEnterPress(event)}
                  autoFocus={true}
                  data-testid="basicTextplace"
                  aria-labelledby="krNameEmpty"
                ></textarea>
              </div>
            )}

            {this.state.addKrFinished && (
              <div className="Press-enter-when-fin-kr">
                {t('press enter when finished')}
              </div>
            )}
            {!this.state.setKr &&(
              <div className="basicKrWrapper" >
                <BasicKrComp
                  krExtractInitialValue={this.state.krExtractInitialValue}
                  krExtractTargetValue={this.state.krExtractTargetValue}
                  krExtractValueType={this.state.krExtractValueType}
                  krExtractDirectionValue={this.state.krExtractDirectionValue}
                  krExtractName={this.state.krExtractName}
                  predicted={this.state.predicted}
                  setKr={this.state.setKr}
                  advancedOptionEn={this.state.advancedOptionEn}
                  addKrValue={this.state.addKrValue}
                  deleteItems={this.deleteItems}
                  saveKrArr={this.props.saveKrArr}
                  saveKrs={this.saveKrs}
                  goalDetails={this.props.goalDetails}
                  resetKr={this.resetKr}
                  id=""
                  editMetricCompFun={this.editMetricCompFun}
                  inlineKrUpdate={this.inlineKrUpdate}
                  displayKrClustering={display_kr_clustering}
                  displayNestedKr={display_nested_kr}
                  isEnabledBiweeklyKR={isEnabledBiweeklyKR}
                  updateKRStates={this.updateAllStates}
                  actions={actions}
                  clusterItem={this.state.clusterItem[0] && this.state.clusterItem[0].cKR ? this.state.clusterItem[0].cKR : []}
                  updateClusterData={this.updateClusterData}
                  nlpTagLists = {this.state.nlpTags}
                  teamId = {this.props.teamId}
                  addOkrData = {this.props.addOkrData}
                  reqFieldError = {this.state.reqFieldError}
                />
              </div>
            )}
            <CoauthorButtonGroup>
              {this.state.advanceOptionEn && (
                <div
                  tabIndex={0}
                  role="button"
                  aria-label={t("Advanced-options")}
                  className="Advanced-options"
                  onClick={() => this.advancedFunc("", this.state.krItem)}
                  onKeyDown={e => KeyDownEvent(e, () => {
                    this.advancedFunc("", this.state.krItem);
                  })}
                  data-testid="Advanced_options"
                >
                  {t('Advanced options')}{" "}
                </div>
              )}
              {this.state.setKr && (
                <CoauthorButtonWithPortal onClick={(e, portalNode) => this.handleCoauthorClick(e, this.getTextFocus.value, portalNode, { id: TEXTAREA_IDS.newKR, type: "kr", krSlotIndex: -1 })} />
              )}
            </CoauthorButtonGroup>
          </div>
        )}
        {this.state.deleteKrList && (
          <DeleteCommonModal
            exitDeleteModal={this.exitDeleteModal}
            deleteItems={this.deleteItems}
            title={this.state.deleteTitle}
            deleteContentOne={this.state.deleteContentOne}
            deleteContentSecond={t('leave without saving your key result?')}
            buttonText={this.state.buttonText}
            deleteContentSecondParam={t('delete key result?')}
            deletefirstTitle={t('Delete Key Result')}
            deleteContentBodyText={t('Are you sure you want to delete this key result? This cannot be undone.')}
            id={this.state.deleteKrId}
          />
        )}
        {this.state.resetDefaultWeightsOpen && (
          <DeleteCommonModal
            exitDeleteModal={this.exitResetDefaultWeightsModal}
            deleteItems={this.confirmResetDefaultWeights}
            title={t('Reset to default weights?')}
            deleteContentOne={t(
              'Current key result weights will be discarded and replaced with automatic weights based on this objective’s time periods.'
            )}
            deleteContentSecond=""
            buttonText={t('Reset weights')}
            deleteContentBodyText={t(
              'The objective progress will be recalculated. This cannot be undone.'
            )}
            id=""
            disableScrollLock
            disableEnforceFocus
          />
        )}
        <div id="mySidenas"></div>
      </div>
    );
  }
}

export default AddKrSection
